import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Tabs } from '@insight/toolkit-react'
import RoundedTab from './Components/RoundedTab'

const SearchTabs = ({ tabs, onTabClick, initialSelectedTab, expand, restrictNavigation = false }) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0])
  const onTabPress = (selected) => {
    if (onTabClick) {
      onTabClick(selected)
      setSelectedTab(selected)
    }
  }

  useEffect(() => {
    if (initialSelectedTab >= 0) {
      setSelectedTab(tabs[initialSelectedTab])
    }
  }, [initialSelectedTab, tabs])

  return (
    <div className="o-grid">
      {!restrictNavigation && <Tabs expand={expand}>
        {tabs.map((tab, index) => {
          const {
            content,
            contentClassName,
            id,
            name,
            tabClassName,
            ...tabProps
          } = tab
          const props = {
            'aria-controls': `${id}`,
            id,
            isSelected: id === selectedTab?.id,
            key: id,
            onClick: () => onTabPress(tab),
            ...tabProps,
          }

          return (
            <RoundedTab {...props} key={index * 2}>
              {name}
            </RoundedTab>
          )
        })}
      </Tabs>}

      <div role={!restrictNavigation ? 'tabpanel' : undefined}
        aria-labelledby={!restrictNavigation && selectedTab?.id ? selectedTab.id : undefined}
        className={`c-search-page__search__tabpanel${restrictNavigation ? ' c-search-page__search__tabpanel--no-tabs' : ''}`}>
        {selectedTab?.content}
      </div>
    </div>
  )
}

SearchTabs.propTypes = {
  expand: PropTypes.bool,
  initialSelectedTab: PropTypes.number,
  onTabClick: PropTypes.func,
  restrictNavigation: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node.isRequired,
      contentClassName: PropTypes.string,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      tabClassName: PropTypes.string,
    })
  ).isRequired,
}

export default SearchTabs
